module.exports = __webpack_public_path__ + "static/media/view.7e153fd1.svg";